import { Button } from "@/components/ui/button";
import { Download, Check, Loader2 } from "lucide-react";
import { usePWA } from "@/context/PWAProvider";

const PWAInstallButton = () => {
    const { canInstall, isInstalled, isInstalling, install } = usePWA();

    if (isInstalled) {
        return (
            <Button variant="outline" size="sm" disabled>
                <Check className="size-4 mr-2" />
                Installed
            </Button>
        );
    }

    if (canInstall) {
        return (
            <Button 
                variant="default" 
                size="default" 
                onClick={install}
                disabled={isInstalling}
            >
                {isInstalling ? (
                    <Loader2 className="size-4 mr-2 animate-spin" />
                ) : (
                    <Download className="size-4 mr-2" />
                )}
                {isInstalling ? "Installing..." : "Install App"}
            </Button>
        );
    }

    return null;
};

export default PWAInstallButton;
